import { useAuditApi } from './common/auditApi';

export function useOutboundDeliveryAuditApi() {
  return useAuditApi({
    url: 'delivery/outbound',
    translateTitle: (t) => t.audit.actions.fetchOutboundDelivery.title,
    translateError: (t) => t.audit.actions.fetchOutboundDelivery.error,
  });
}
